<template>
  <CommonAnalyticsTable
    :stats="this.stats"
    :total="this.total"
    :currentMonth="currentMonth"
    :showGrossSalesCount="showGrossSalesCount"
    :order="order"
    @sort="handleSort"
  />
</template>
<script>
import CommonAnalyticsTable from "@/components/analytics/retail/utils/CommonAnalyticsTable.vue";

export default {
  components: {
    CommonAnalyticsTable,
  },

  emits: ["sort"],

  props: ["stats", "total", "currentMonth", "showGrossSalesCount", "order"],

  methods: {
    handleSort(column) {
      this.$emit("sort", column);
    },
  },
};
</script>
